<template>
  <div class="page-callendar-current">
    <v-row>
      <v-col>
        <template v-if="isProcessing">
          <h4 class="mt-md-5 text-center cursor-default">
            <v-progress-circular indeterminate></v-progress-circular>
          </h4>
        </template>
        <template v-else-if="events.length">
          <v-alert class="d-none d-print-block" dense type="info">
            {{ calendarDateFormatted }}
          </v-alert>
          <transition-group name="list" tag="p">
            <CalendarEvent
              v-for="event in events"
              :key="event.id"
              :event-data="event"
              @updateStatus="changeStatus"
              @updated="getEvents"
              @deleted="getEvents"
            />
          </transition-group>
        </template>

        <template v-else>
          <h4 class="mt-md-5 text-center cursor-default">
            There is no events in that time period
          </h4>
        </template>
      </v-col>
    </v-row>

    <ConfirmDialog ref="confirmDialog" />
  </div>
</template>

<script>
import moment from 'moment';
import eventBus from '@/eventBus';
import eventsApi from '@/api/v1/recruiter/events';
import CalendarEvent from '@/components/Recruiter/Calendar/CalendarEvent.vue';
import ConfirmDialog from '@/components/Common/ConfirmDialog.vue';

export default {
  components: {
    CalendarEvent,
    ConfirmDialog,
  },

  data() {
    return {
      isDialogVisible: false,
      isProcessing: false,
      events: [],
    };
  },

  computed: {
    calendarDate() {
      return this.$store.getters.getDate;
    },

    calendarDateFormatted() {
      return this.calendarDate.toISOString().substr(0, 10);
    },

    selectedUserId() {
      return this.$store.getters.getUser;
    },
  },

  watch: {
    selectedUserId() {
      this.getEvents();
    },

    calendarDate() {
      this.getEvents();
    },
  },

  created() {
    this.getEvents();
  },

  mounted() {
    eventBus.$on('update-events', () => {
      this.getEvents();
    });
  },

  methods: {
    getEvents() {
      this.isProcessing = true;

      const parameters = {
        user_id: this.selectedUserId,
        date_range: [moment(this.$store.getters.getDate).format('DD-MM-YYYY')],
        from_contact: false,
      };

      eventsApi
        .index(parameters)
        .then(resp => {
          this.events = resp.data;
        })
        .catch(err => {
          this.$store.dispatch('showError', err.response.data.errors);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    changeStatus(event) {
      eventsApi
        .update(event.id, event)
        .then(() => {
          this.getEvents();
        })
        .catch(err => {
          this.$store.dispatch('showError', err.response.data.errors);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-callendar-current {
  max-width: 820px;
  margin: 0 auto;
  padding: 0px 12px 24px;
  @media (min-width: 960px) {
    padding-top: 24px;
  }
}
.list-enter-active {
  transition: all 0.3s;
}
.list-leave-active {
  transition: all 0.1s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
</style>
